import React, { useEffect, useState } from "react";
import Header from "../general/Header";
import Aside from "../general/Aside";
import Footer from "../general/Footer";
import { Link } from "react-router-dom";
import Loading from "../general/Loading";
import axios from '../../axios/axiosconf';
import Unauthorized from "../general/Unauthorized";
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
} from 'chart.js';

function ListadoTemperaturaHumedad() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [hasPermission, setHasPermission] = useState(false);
    const [client, setClient] = useState([]);
    const [registros, setRegistros] = useState([]);
    const [usuarios, setUsuarios] = useState([]);
    const [areas, setAreas] = useState([]);
    
    // Filtros
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [responsableFiltro, setResponsableFiltro] = useState('');
    const [localizacionFiltro, setLocalizacionFiltro] = useState('');
    
    // Selección de registro
    const [registroSeleccionadoId, setRegistroSeleccionadoId] = useState(null);
    
    // Paginación
    const [paginaActual, setPaginaActual] = useState(1);
    const registrosPorPagina = 12;
    
    // Modal Ver Detalles
    const [showModalDetalles, setShowModalDetalles] = useState(false);
    const [registroDetalles, setRegistroDetalles] = useState(null);
    
    // Modal Ver Gráfico
    const [showModalGrafico, setShowModalGrafico] = useState(false);

    // Estado para dropdown de opciones
    const [showDropdownOpciones, setShowDropdownOpciones] = useState(false);

    // Registrar componentes de Chart.js
    ChartJS.register(
        CategoryScale,
        LinearScale,
        PointElement,
        LineElement,
        Title,
        Tooltip,
        Legend
    );

    useEffect(() => {
        const hoy = new Date();
        const inicioMes = new Date(hoy.getFullYear(), hoy.getMonth(), 1);
        const finMes = new Date(hoy.getFullYear(), hoy.getMonth() + 1, 0);
        
        setFechaInicio(inicioMes.toISOString().split('T')[0]);
        setFechaFin(finMes.toISOString().split('T')[0]);

        let userdata = [];
        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const tienePermiso = userdata.up && userdata.up.includes('gestionarTemperaturaHumedad');
        
        if (!tienePermiso) {
            setHasPermission(false);
            return;
        }

        setHasPermission(true);

        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        axios.get('/usuarios-basico')
            .then(response => {
                if (response.status === 200) {
                    setUsuarios(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });

        axios.get('/areas-localizacion')
            .then(response => {
                if (response.status === 200) {
                    setAreas(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    }, []);

    useEffect(() => {
        if (loggedIn && fechaInicio && fechaFin) {
            cargarRegistros();
        }
    }, [loggedIn, fechaInicio, fechaFin, responsableFiltro, localizacionFiltro]);

    const cargarRegistros = () => {
        const params = new URLSearchParams({
            fecha_inicio: fechaInicio,
            fecha_fin: fechaFin
        });

        if (responsableFiltro) params.append('responsable_id', responsableFiltro);
        if (localizacionFiltro) params.append('localizacion_id', localizacionFiltro);

        axios.get('/registros-temperatura-humedad?' + params.toString())
            .then(response => {
                if (response.status === 200) {
                    setRegistros(response.data);
                }
            })
            .catch(error => {
                console.log('err: ' + error);
            });
    };

    const formatearFecha = (fechaString) => {
        // Extraer año, mes y día directamente del string para evitar problemas de zona horaria
        const [year, month, day] = fechaString.split('T')[0].split('-');
        return `${day}/${month}/${year}`;
    };

    const getNombreResponsable = (responsableId) => {
        const usuario = usuarios.find(u => u.id === responsableId);
        return usuario ? `${usuario.name} ${usuario.lastname || ''}`.trim() : 'N/A';
    };

    const verDetalles = (registro) => {
        setRegistroDetalles(registro);
        setShowModalDetalles(true);
    };

    const eliminarRegistro = async (id) => {
        if (!window.confirm('¿Está seguro de eliminar este registro?')) {
            return;
        }

        try {
            await axios.delete(`/registro-temperatura-humedad/${id}`);
            alert('Registro eliminado exitosamente');
            cargarRegistros();
            setRegistroSeleccionadoId(null);
        } catch (error) {
            console.error('Error al eliminar:', error);
            alert('Error al eliminar: ' + (error.response?.data?.message || error.message));
        }
    };

    const getRegistroSeleccionado = () => {
        return registros.find(r => r.id === registroSeleccionadoId);
    };

    const handleSeleccionRegistro = (registroId) => {
        setRegistroSeleccionadoId(registroSeleccionadoId === registroId ? null : registroId);
    };

    const indiceUltimoRegistro = paginaActual * registrosPorPagina;
    const indicePrimerRegistro = indiceUltimoRegistro - registrosPorPagina;
    const registrosPaginados = registros.slice(indicePrimerRegistro, indiceUltimoRegistro);
    const totalPaginas = Math.ceil(registros.length / registrosPorPagina);

    const cambiarPagina = (numeroPagina) => {
        setPaginaActual(numeroPagina);
        setRegistroSeleccionadoId(null);
    };

    useEffect(() => {
        setPaginaActual(1);
    }, [fechaInicio, fechaFin, responsableFiltro, localizacionFiltro]);

    // Cerrar dropdown al hacer clic fuera
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showDropdownOpciones && !event.target.closest('.btn-group')) {
                setShowDropdownOpciones(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showDropdownOpciones]);

    const exportarAExcel = async () => {
        if (registros.length === 0) {
            alert('No hay registros para exportar');
            return;
        }

        try {
            // Construir parámetros de filtro
            const params = new URLSearchParams({
                fecha_inicio: fechaInicio,
                fecha_fin: fechaFin
            });

            if (responsableFiltro) params.append('responsable_id', responsableFiltro);
            if (localizacionFiltro) params.append('localizacion_id', localizacionFiltro);

            // Llamar al endpoint del backend que genera Excel con gráficos
            const response = await axios.get('/exportar-temperatura-humedad-excel?' + params.toString(), {
                responseType: 'blob'
            });

            // Crear URL del blob y descargar
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Temperatura_Humedad_${fechaInicio}_${fechaFin}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Error al exportar:', error);
            alert('Error al exportar: ' + (error.response?.data?.message || error.message));
        }
    };

    // Calcular estadísticas
    const calcularEstadisticas = () => {
        if (registros.length === 0) {
            return {
                promedioTemp: 0,
                promedioHum: 0,
                maxTemp: 0,
                minTemp: 0,
                maxHum: 0,
                minHum: 0
            };
        }

        const temperaturas = registros.map(r => parseFloat(r.temperatura));
        const humedades = registros.map(r => parseFloat(r.humedad));

        return {
            promedioTemp: (temperaturas.reduce((a, b) => a + b, 0) / temperaturas.length).toFixed(1),
            promedioHum: (humedades.reduce((a, b) => a + b, 0) / humedades.length).toFixed(1),
            maxTemp: Math.max(...temperaturas).toFixed(1),
            minTemp: Math.min(...temperaturas).toFixed(1),
            maxHum: Math.max(...humedades).toFixed(1),
            minHum: Math.min(...humedades).toFixed(1)
        };
    };

    // Preparar datos para gráficos
    const prepararDatosGrafico = () => {
        const labels = registros.map(r => {
            const [year, month, day] = r.fecha.split('T')[0].split('-');
            return `${day}/${month}`;
        });
        const temperaturas = registros.map(r => parseFloat(r.temperatura));
        const humedades = registros.map(r => parseFloat(r.humedad));

        return {
            labels,
            datasets: [
                {
                    label: 'Temperatura (°C)',
                    data: temperaturas,
                    borderColor: 'rgb(255, 99, 132)',
                    backgroundColor: 'rgba(255, 99, 132, 0.5)',
                    yAxisID: 'y',
                },
                {
                    label: 'Humedad (%)',
                    data: humedades,
                    borderColor: 'rgb(53, 162, 235)',
                    backgroundColor: 'rgba(53, 162, 235, 0.5)',
                    yAxisID: 'y1',
                }
            ]
        };
    };

    const opcionesGrafico = {
        responsive: true,
        maintainAspectRatio: false,
        interaction: {
            mode: 'index',
            intersect: false,
        },
        stacked: false,
        plugins: {
            title: {
                display: true,
                text: 'Temperatura y Humedad - Período Seleccionado',
                font: {
                    size: 14
                }
            },
            legend: {
                display: true,
                position: 'top',
            }
        },
        scales: {
            y: {
                type: 'linear',
                display: true,
                position: 'left',
                title: {
                    display: true,
                    text: 'Temperatura (°C)',
                    font: {
                        size: 11
                    }
                },
                ticks: {
                    font: {
                        size: 10
                    }
                }
            },
            y1: {
                type: 'linear',
                display: true,
                position: 'right',
                title: {
                    display: true,
                    text: 'Humedad (%)',
                    font: {
                        size: 11
                    }
                },
                ticks: {
                    font: {
                        size: 10
                    }
                },
                grid: {
                    drawOnChartArea: false,
                },
            },
            x: {
                ticks: {
                    font: {
                        size: 10
                    }
                }
            }
        },
    };

    if (hasPermission === false) {
        return <Unauthorized />;
    }

    if (loggedIn) {
        return (
            <div className="hold-transition">
                <style>{`
                    .table-info {
                        background-color: #f6fcfd !important;
                        border-left: 4px solid #17a2b8;
                    }
                    .table tbody tr:hover {
                        background-color: #f6fcfd;
                        transform: scale(1.001);
                        transition: all 0.2s ease;
                    }
                `}</style>
                <Header client={client} />
                <Aside client={client} activelink="indicators" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item"><Link to="/indicadores">Indicadores</Link></li>
                                        <li className="breadcrumb-item">Temperatura y Humedad</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Registros de Temperatura y Humedad</h1>
                                </div>
                                <div className="col-sm-4">
                                    <div className="float-right">
                                        <div className="btn-group mr-2" style={{position: 'relative'}}>
                                            <button 
                                                type="button" 
                                                className="btn btn-secondary" 
                                                onClick={() => setShowDropdownOpciones(!showDropdownOpciones)}
                                                disabled={registros.length === 0}
                                                title="Opciones de visualización y exportación"
                                            >
                                                <i className="fas fa-ellipsis-v"></i>
                                            </button>
                                            {showDropdownOpciones && registros.length > 0 && (
                                                <div 
                                                    className="dropdown-menu show" 
                                                    style={{position: 'absolute', right: 0, top: '100%', zIndex: 1000}}
                                                >
                                                    <button 
                                                        className="dropdown-item" 
                                                        onClick={() => {
                                                            setShowModalGrafico(true);
                                                            setShowDropdownOpciones(false);
                                                        }}
                                                    >
                                                        <i className="fas fa-chart-line text-primary"></i> Ver Gráfico
                                                    </button>
                                                    <button 
                                                        className="dropdown-item" 
                                                        onClick={() => {
                                                            exportarAExcel();
                                                            setShowDropdownOpciones(false);
                                                        }}
                                                    >
                                                        <i className="fas fa-file-excel text-success"></i> Exportar Excel
                                                    </button>
                                                </div>
                                            )}
                                        </div>
                                        <Link to="/crear-registro-temperatura-humedad" className="btn btn-info">
                                            <i className="fas fa-plus"></i> Nuevo Registro
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            
                            {/* Filtros */}
                            <div className="card card-info card-outline">
                                <div className="card-header">
                                    <h5><b>Filtros</b></h5>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Fecha Inicio</label>
                                                <input 
                                                    type="date" 
                                                    className="form-control" 
                                                    value={fechaInicio}
                                                    onChange={(e) => setFechaInicio(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Fecha Fin</label>
                                                <input 
                                                    type="date" 
                                                    className="form-control" 
                                                    value={fechaFin}
                                                    onChange={(e) => setFechaFin(e.target.value)}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Responsable</label>
                                                <select 
                                                    className="form-control" 
                                                    value={responsableFiltro}
                                                    onChange={(e) => setResponsableFiltro(e.target.value)}
                                                >
                                                    <option value="">Todos</option>
                                                    {usuarios.map(usuario => (
                                                        <option key={usuario.id} value={usuario.id}>
                                                            {usuario.name} {usuario.lastname}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label>Área/Localización</label>
                                                <select 
                                                    className="form-control" 
                                                    value={localizacionFiltro}
                                                    onChange={(e) => setLocalizacionFiltro(e.target.value)}
                                                >
                                                    <option value="">Todas</option>
                                                    {areas.map(area => (
                                                        <option key={area.id} value={area.id}>{area.area_localizacion}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Barra de acciones */}
                            {registroSeleccionadoId && (
                                <div className="card card-primary card-outline shadow-sm">
                                    <div className="card-header bg-gradient-light">
                                        <div className="d-flex justify-content-between align-items-center flex-wrap">
                                            <div className="d-flex align-items-center flex-wrap">
                                                <h5 className="mb-0 mr-3">
                                                    <i className="fas fa-check-circle text-success"></i> 
                                                    <strong>Registro seleccionado</strong>
                                                </h5>
                                            </div>
                                            <button 
                                                className="btn btn-sm btn-outline-secondary mt-2 mt-md-0"
                                                onClick={() => setRegistroSeleccionadoId(null)}
                                            >
                                                <i className="fas fa-times"></i> Deseleccionar
                                            </button>
                                        </div>
                                    </div>
                                    <div className="card-body py-3">
                                        <div className="btn-toolbar" role="toolbar">
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button 
                                                    className="btn btn-outline-info"
                                                    onClick={() => verDetalles(getRegistroSeleccionado())}
                                                    title="Ver Detalles Completos"
                                                >
                                                    <i className="fas fa-eye"></i> Ver Detalles
                                                </button>
                                            </div>
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <Link 
                                                    to={`/editar-registro-temperatura-humedad/${registroSeleccionadoId}`}
                                                    className="btn btn-outline-warning"
                                                    title="Editar Registro"
                                                >
                                                    <i className="fas fa-edit"></i> Editar
                                                </Link>
                                            </div>
                                            <div className="btn-group mr-2 mb-2" role="group">
                                                <button 
                                                    className="btn btn-outline-danger"
                                                    onClick={() => eliminarRegistro(registroSeleccionadoId)}
                                                    title="Eliminar Registro"
                                                >
                                                    <i className="fas fa-trash"></i> Eliminar
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {/* Tabla de registros */}
                            <div className="card card-info card-outline">
                                <div className="card-body p-0" style={{overflowX: 'auto'}}>
                                    <table className="table table-bordered table-hover" style={{marginBottom: 0}}>
                                        <thead>
                                            <tr>
                                                <th width="50">Seleccionar</th>
                                                <th>Fecha</th>
                                                <th>Hora</th>
                                                <th>Temperatura</th>
                                                <th>Humedad</th>
                                                <th>Área/Localización</th>
                                                <th>Responsable</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {registrosPaginados.map(registro => (
                                                <tr 
                                                    key={registro.id} 
                                                    className={registroSeleccionadoId === registro.id ? 'table-info' : ''}
                                                    style={{cursor: 'pointer'}}
                                                    onClick={() => handleSeleccionRegistro(registro.id)}
                                                >
                                                    <td className="text-center">
                                                        <input 
                                                            type="radio" 
                                                            name="registroSeleccionado"
                                                            checked={registroSeleccionadoId === registro.id}
                                                            onChange={() => handleSeleccionRegistro(registro.id)}
                                                            onClick={(e) => e.stopPropagation()}
                                                        />
                                                    </td>
                                                    <td>{formatearFecha(registro.fecha)}</td>
                                                    <td>{registro.hora}</td>
                                                    <td className="text-center">
                                                        <span className="badge badge-info badge-lg">
                                                            {parseFloat(registro.temperatura).toFixed(1)}°C
                                                        </span>
                                                    </td>
                                                    <td className="text-center">
                                                        <span className="badge badge-primary badge-lg">
                                                            {parseFloat(registro.humedad).toFixed(1)}%
                                                        </span>
                                                    </td>
                                                    <td>{registro.area_localizacion || 'N/A'}</td>
                                                    <td>{getNombreResponsable(registro.responsable_id)}</td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                    {registros.length === 0 && (
                                        <div className="text-center p-4">
                                            <p>No se encontraron registros para los filtros seleccionados.</p>
                                        </div>
                                    )}
                                </div>
                                
                                {/* Paginador */}
                                {registros.length > registrosPorPagina && (
                                    <div className="card-footer clearfix">
                                        <div className="row align-items-center">
                                            <div className="col-md-6">
                                                <p className="mb-0">
                                                    Mostrando {indicePrimerRegistro + 1} a {Math.min(indiceUltimoRegistro, registros.length)} de {registros.length} registros
                                                </p>
                                            </div>
                                            <div className="col-md-6">
                                                <ul className="pagination pagination-sm m-0 float-right">
                                                    <li className={`page-item ${paginaActual === 1 ? 'disabled' : ''}`}>
                                                        <button 
                                                            className="page-link" 
                                                            onClick={() => cambiarPagina(paginaActual - 1)}
                                                            disabled={paginaActual === 1}
                                                        >
                                                            «
                                                        </button>
                                                    </li>
                                                    
                                                    {[...Array(totalPaginas)].map((_, index) => {
                                                        const numeroPagina = index + 1;
                                                        if (
                                                            numeroPagina === 1 ||
                                                            numeroPagina === totalPaginas ||
                                                            (numeroPagina >= paginaActual - 1 && numeroPagina <= paginaActual + 1)
                                                        ) {
                                                            return (
                                                                <li 
                                                                    key={numeroPagina} 
                                                                    className={`page-item ${paginaActual === numeroPagina ? 'active' : ''}`}
                                                                >
                                                                    <button 
                                                                        className="page-link" 
                                                                        onClick={() => cambiarPagina(numeroPagina)}
                                                                    >
                                                                        {numeroPagina}
                                                                    </button>
                                                                </li>
                                                            );
                                                        } else if (
                                                            numeroPagina === paginaActual - 2 ||
                                                            numeroPagina === paginaActual + 2
                                                        ) {
                                                            return <li key={numeroPagina} className="page-item disabled"><span className="page-link">...</span></li>;
                                                        }
                                                        return null;
                                                    })}
                                                    
                                                    <li className={`page-item ${paginaActual === totalPaginas ? 'disabled' : ''}`}>
                                                        <button 
                                                            className="page-link" 
                                                            onClick={() => cambiarPagina(paginaActual + 1)}
                                                            disabled={paginaActual === totalPaginas}
                                                        >
                                                            »
                                                        </button>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>

                        </div>
                    </section>
                </div>

                {/* Modal Detalles */}
                {showModalDetalles && registroDetalles && (
                    <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}} tabIndex="-1">
                        <div className="modal-dialog modal-lg">
                            <div className="modal-content">
                                <div className="modal-header bg-info text-white">
                                    <h4 className="modal-title">
                                        <i className="fas fa-thermometer-half mr-2"></i>Detalles del Registro
                                    </h4>
                                    <button type="button" className="close text-white" onClick={() => setShowModalDetalles(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row">
                                        <div className="col-md-6">
                                            <p><strong>Fecha:</strong> {formatearFecha(registroDetalles.fecha)}</p>
                                            <p><strong>Hora:</strong> {registroDetalles.hora}</p>
                                            <p><strong>Temperatura:</strong> <span className="badge badge-info">{parseFloat(registroDetalles.temperatura).toFixed(1)}°C</span></p>
                                            <p><strong>Humedad:</strong> <span className="badge badge-primary">{parseFloat(registroDetalles.humedad).toFixed(1)}%</span></p>
                                        </div>
                                        <div className="col-md-6">
                                            <p><strong>Área/Localización:</strong> {registroDetalles.area_localizacion || 'N/A'}</p>
                                            <p><strong>Responsable:</strong> {getNombreResponsable(registroDetalles.responsable_id)}</p>
                                        </div>
                                    </div>
                                    
                                    <hr/>
                                    
                                    <div className="form-group">
                                        <label><strong>Observaciones Generales:</strong></label>
                                        <div className="border p-2 bg-light" style={{minHeight: '60px'}}>
                                            {registroDetalles.observaciones_generales || 'Sin observaciones'}
                                        </div>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label><strong>Análisis de Condiciones Ambientales:</strong></label>
                                        <div className="border p-2 bg-light" style={{minHeight: '60px'}}>
                                            {registroDetalles.analisis_condiciones_ambientales || 'Sin análisis'}
                                        </div>
                                    </div>
                                    
                                    <div className="form-group">
                                        <label><strong>Acciones Tomadas frente a Desviaciones:</strong></label>
                                        <div className="border p-2 bg-light" style={{minHeight: '60px'}}>
                                            {registroDetalles.acciones_tomadas_desviaciones || 'Sin acciones registradas'}
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalDetalles(false)}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {/* Modal Gráfico */}
                {showModalGrafico && registros.length > 0 && (
                    <div className="modal fade show" style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.5)'}} tabIndex="-1">
                        <div className="modal-dialog modal-xl" style={{maxWidth: '95%'}}>
                            <div className="modal-content">
                                <div className="modal-header bg-info text-white">
                                    <h4 className="modal-title">
                                        <i className="fas fa-chart-line mr-2"></i>Gráfico de Temperatura y Humedad
                                    </h4>
                                    <button type="button" className="close text-white" onClick={() => setShowModalGrafico(false)}>
                                        <span>&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body" style={{maxHeight: '80vh', overflowY: 'auto'}}>
                                    {/* Estadísticas */}
                                    <div className="row mb-4">
                                        <div className="col-md-12">
                                            <div className="card card-info card-outline">
                                                <div className="card-header">
                                                    <h5 className="mb-0"><strong>Estadísticas del Período</strong></h5>
                                                </div>
                                                <div className="card-body">
                                                    <div className="row text-center">
                                                        <div className="col-md-6">
                                                            <h6 className="text-info"><strong>Temperatura (°C)</strong></h6>
                                                            <div className="row">
                                                                <div className="col-4">
                                                                    <div className="info-box bg-info">
                                                                        <div className="info-box-content">
                                                                            <span className="info-box-text">Promedio</span>
                                                                            <span className="info-box-number">{calcularEstadisticas().promedioTemp}°C</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-4">
                                                                    <div className="info-box bg-danger">
                                                                        <div className="info-box-content">
                                                                            <span className="info-box-text">Máxima</span>
                                                                            <span className="info-box-number">{calcularEstadisticas().maxTemp}°C</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-4">
                                                                    <div className="info-box bg-info">
                                                                        <div className="info-box-content">
                                                                            <span className="info-box-text">Mínima</span>
                                                                            <span className="info-box-number">{calcularEstadisticas().minTemp}°C</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <h6 className="text-info"><strong>Humedad (%)</strong></h6>
                                                            <div className="row">
                                                                <div className="col-4">
                                                                    <div className="info-box bg-info">
                                                                        <div className="info-box-content">
                                                                            <span className="info-box-text">Promedio</span>
                                                                            <span className="info-box-number">{calcularEstadisticas().promedioHum}%</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-4">
                                                                    <div className="info-box bg-success">
                                                                        <div className="info-box-content">
                                                                            <span className="info-box-text">Máxima</span>
                                                                            <span className="info-box-number">{calcularEstadisticas().maxHum}%</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-4">
                                                                    <div className="info-box bg-warning">
                                                                        <div className="info-box-content">
                                                                            <span className="info-box-text">Mínima</span>
                                                                            <span className="info-box-number">{calcularEstadisticas().minHum}%</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Gráfico */}
                                    <div className="row" style={{marginBottom: '30px'}}>
                                        <div className="col-md-12">
                                            <div className="card">
                                                <div className="card-body" style={{height: '300px', overflow: 'hidden'}}>
                                                    <Line options={opcionesGrafico} data={prepararDatosGrafico()} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Tabla de datos */}
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="card card-info card-outline">
                                                <div className="card-header">
                                                    <h5 className="mb-0"><strong>Datos del Período</strong></h5>
                                                </div>
                                                <div className="card-body p-0" style={{maxHeight: '250px', overflowY: 'auto'}}>
                                                    <table className="table table-bordered table-hover table-sm mb-0">
                                                        <thead className="thead-light" style={{position: 'sticky', top: 0, zIndex: 10, backgroundColor: '#f8f9fa'}}>
                                                            <tr>
                                                                <th>Fecha</th>
                                                                <th>Hora</th>
                                                                <th className="text-center">Temperatura</th>
                                                                <th className="text-center">Humedad</th>
                                                                <th>Área/Localización</th>
                                                                <th>Responsable</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {registros.map(registro => (
                                                                <tr key={registro.id}>
                                                                    <td>{formatearFecha(registro.fecha)}</td>
                                                                    <td>{registro.hora}</td>
                                                                    <td className="text-center">
                                                                        <span className="badge badge-danger">
                                                                            {parseFloat(registro.temperatura).toFixed(1)}°C
                                                                        </span>
                                                                    </td>
                                                                    <td className="text-center">
                                                                        <span className="badge badge-primary">
                                                                            {parseFloat(registro.humedad).toFixed(1)}%
                                                                        </span>
                                                                    </td>
                                                                    <td>{registro.area_localizacion || 'N/A'}</td>
                                                                    <td>{getNombreResponsable(registro.responsable_id)}</td>
                                                                </tr>
                                                            ))}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={() => setShowModalGrafico(false)}>
                                        Cerrar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return <Loading />;
}

export default ListadoTemperaturaHumedad;
